import { DocumentReceiptEntity } from '../../../generated-api';
import { CSVConvertResult } from '../defs/types';

export function receiptsToCsv(
  data: {
    summary: Record<string, string | number>;
    latest_revision: DocumentReceiptEntity;
  }[]
): CSVConvertResult {
  const csvData = data.flatMap((item) => {
    const defaultDetail = {
      税率: '10',
      税抜き金額: '',
      税額: '',
      税込み金額: '',
      勘定科目名: '-',
      勘定科目コード: '-',
      取引内容: '',
    };
    const row = item.latest_revision.receipt_details?.map((detail) => {
      return {
        ...item.summary,
        税率: detail.tax_percent?.toString() ?? '',
        税抜き金額: detail.amount_without_tax?.toString() ?? '',
        税額: detail.tax_amount?.toString() ?? '',
        税込み金額: detail.amount_with_tax?.toString() ?? '',
        勘定科目名: detail.account ?? '-',
        勘定科目コード: detail.account_code ?? '-',
        取引内容: detail.transaction_content ?? '',
      };
    }) ?? [{ ...item.summary, ...defaultDetail }];
    return row;
  });
  return {
    csv: csvData,
  };
}
